import React, { useState } from 'react';
import { 
  Search,
  ShieldAlert,
  GraduationCap,
  Scale,
  MapPin,
  Home,
  Database,
  Briefcase,
  Zap,
  Milk
} from 'lucide-react';

const WebsiteContents = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const apps = [
    { 
      id: 1, 
      name: 'Amudhasurabhi', 
      path: '/admin/amudhasurabhi', 
      icon: Milk,
      color: 'bg-pink-50',
      iconColor: 'text-pink-600',
      borderColor: 'border-pink-200'
    },
    { 
      id: 2, 
      name: 'Development Action Plan (DAP) Portal', 
      path: '/admin/dap', 
      icon: Database,
      color: 'bg-purple-50',
      iconColor: 'text-purple-600',
      borderColor: 'border-purple-200'
    },
    { 
      id: 3, 
      name: 'Hostel Management Information System (HMIS)', 
      path: '/admin/hmis', 
      icon: Home,
      color: 'bg-orange-50',
      iconColor: 'text-orange-600',
      borderColor: 'border-orange-200'
    },
    { 
      id: 4, 
      name: 'Land Acquisition Survey', 
      path: '/admin/land', 
      icon: MapPin,
      color: 'bg-green-50',
      iconColor: 'text-green-600',
      borderColor: 'border-green-200'
    },
    { 
      id: 5, 
      name: 'Legal Management System (LMS)', 
      path: '/admin/lms', 
      icon: Scale,
      color: 'bg-indigo-50',
      iconColor: 'text-indigo-600',
      borderColor: 'border-indigo-200'
    },
    { 
      id: 6, 
      name: 'Overseas Scholarship Portal', 
      path: '/admin/overseas-scholarship', 
      icon: GraduationCap,
      color: 'bg-blue-50',
      iconColor: 'text-blue-600',
      borderColor: 'border-blue-200'
    },
    { 
      id: 7, 
      name: 'Prevention of Atrocities (PoA) Portal', 
      path: '/admin/poa', 
      icon: ShieldAlert,
      color: 'bg-red-50',
      iconColor: 'text-red-600',
      borderColor: 'border-red-200'
    },
    { 
      id: 8, 
      name: 'Project Management Office (PMO)', 
      path: '/admin/pmo', 
      icon: Briefcase,
      color: 'bg-teal-50',
      iconColor: 'text-teal-600',
      borderColor: 'border-teal-200'
    },
    { 
      id: 9, 
      name: 'Tamil Nadu State Scholarship Portal (TNSSP)', 
      path: '/admin/tnssp', 
      icon: GraduationCap,
      color: 'bg-cyan-50',
      iconColor: 'text-cyan-600',
      borderColor: 'border-cyan-200'
    },
    { 
      id: 10, 
      name: 'Viduthipaarvai', 
      path: '/admin/viduthipaarvai', 
      icon: Zap,
      color: 'bg-yellow-50',
      iconColor: 'text-yellow-600',
      borderColor: 'border-yellow-200'
    },
  ];

  const filteredApps = apps.filter(app =>
    app.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800">My Applications</h1>
        <p className="text-gray-600 mt-1">Access and manage your applications</p>
      </div>

      {/* Search Bar */}
      <div className="bg-white border border-gray-200 p-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="Search applications..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3d82c4] focus:border-transparent"
          />
        </div>
      </div>

      {/* Apps Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {filteredApps.map(app => {
          const IconComponent = app.icon;
          return (
            <div
              key={app.id}
              className={`bg-white border ${app.borderColor} hover:shadow-lg transition-all duration-200 cursor-pointer group`}
            >
              <div className="p-6">
                <div className={`w-14 h-14 ${app.color} flex items-center justify-center mb-4`}>
                  <IconComponent className={`w-7 h-7 ${app.iconColor}`} />
                </div>
                <h3 className="font-semibold text-gray-800 mb-2 group-hover:text-[#3d82c4] transition-colors">
                  {app.name}
                </h3>
                <p className="text-sm text-gray-500">{app.path}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Empty State */}
      {filteredApps.length === 0 && (
        <div className="bg-white border border-gray-200 p-12 text-center">
          <div className="w-16 h-16 bg-gray-100 flex items-center justify-center mx-auto mb-4">
            <Search className="w-8 h-8 text-gray-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-800 mb-2">No applications found</h3>
          <p className="text-gray-600">Try adjusting your search criteria</p>
        </div>
      )}
    </div>
  );
};

export default WebsiteContents;